/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-unused-vars */
import createAxios from "./httpCommon";
import Error from "./error";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../mixpanel";
import { transformPath } from "../App";
import { getParsedLocalStorageItem } from "../components/Navbar/Navbar";
import { localStorageGetItem, localStorageRemoveItem, localStorageSetItem } from "../App";

export default () => {
  const { error } = Error();
  const navigate = useNavigate();
  const userData = getParsedLocalStorageItem("userData");

  const getLatestOrders = (setLoading, showToast, setLatestOrders) => {
    const token = localStorageGetItem("userToken");
    setLoading(true);
    createAxios().then((axios) => {
      axios
        .get("/admin/reports/latest-orders", {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then((response) => {
          setLatestOrders(response?.data);
          setLoading(false);
        })
        .catch((e) => {
          // setLoading(false);
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  const getAdminOrders = (
    setLoading,
    showToast,
    setOrderDetails,
    setOrderDisplayDetails,
    pagination,
    setPagination,
    filters = {}
  ) => {
    let currentPage = 1;
    let itemsPerPage = 20;

    // Adjust pagination if it exists
    if (pagination) {
      currentPage = pagination.currentPage;
      itemsPerPage = pagination.itemsPerPage;
    }
    const token = localStorageGetItem("userToken");
    setLoading(true);
    createAxios().then((axios) => {
      const params = new URLSearchParams({ pageParam: currentPage, sizeParam: itemsPerPage });
      if (filters.search) params.append("search", filters.search);
      if (filters.paymentStatus) params.append("paymentStatus", filters.paymentStatus);
      if (filters.orderStatus) params.append("orderStatus", filters.orderStatus);
      const url = `/admin/order/all?${params.toString()}`;

      axios
        .get(url, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then((response) => {
          setOrderDetails(response?.data?.data?.orders);
          setOrderDisplayDetails(response?.data?.data?.orders);

          // Update pagination state
          if (setPagination) {
            setPagination({
              currentPage: response?.data?.data?.pagination.currentPage,
              itemsPerPage,
              totalPages: response?.data?.data?.pagination.totalPages,
              totalOrders: response?.data?.data?.pagination.totalOrders,
            });
          }
          setLoading(false);
        })
        .catch((e) => {
          // setLoading(false);
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  const getAdminSingleOrder = (orderId, setOrderLoading, showToast, setOrderDetail) => {
    setOrderLoading(true);
    const token = localStorageGetItem("userToken");

    createAxios().then((axios) => {
      axios
        .get(`/admin/order/${orderId}`, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then(async (response) => {
          setOrderDetail(response?.data?.order);
          setTimeout(() => {
            setOrderLoading(false);
          }, 1000);
        })

        .catch((e) => {
          setOrderLoading(false);

          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };
  const orderModify = (orderId, body, setLoading, showToast) => {
    setLoading(true);

    const token = localStorageGetItem("userToken");
    const userData = getParsedLocalStorageItem("userData");
    createAxios().then((axios) => {
      axios
        .put(`/admin/order/modify/${orderId}`, body, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then(async (response) => {
          setLoading(false);

          showToast({
            toastText: "Order modified succesfully",
            isSuccess: true,
          });
          navigate("/admin/orders");
        })

        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  const deleteOrder = (orderId, setShowDeleteModal, setLoading, showToast) => {
    setLoading(true);

    const token = localStorageGetItem("userToken");
    const userData = getParsedLocalStorageItem("userData");
    createAxios().then((axios) => {
      axios
        .delete(`/admin/${orderId}`, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then(async (response) => {
          setLoading(false);
          setShowDeleteModal(false);
          showToast({
            toastText: "Order deleted succesfully",
            isSuccess: true,
          });
          setTimeout(() => {
            if (window.location.pathname.replace(/\/$/, "") === "/admin/orders") {
              window.location.reload();
            } else {
              navigate("/admin/orders");
            }
          }, 1000);
        })

        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };
  const filterOrders = (
    setLoading,
    setOrderDisplayDetails,
    showToast,
    pagination = null,
    setPagination = null,
    filters = {}
  ) => {
    setLoading(true);
    const token = localStorageGetItem("userToken");
    createAxios().then((axios) => {
      // Initialize URL
      let url = "/admin/order/all";

      const params = new URLSearchParams();

      if (filters.isoStartDate) {
        params.append("startDate", filters.isoStartDate);
      }
      if (filters.isoEndDate) {
        params.append("endDate", filters.isoEndDate);
      }
      if (filters.orderStatusType) {
        params.append("orderStatus", filters.orderStatusType);
      }
      if (filters.deliveryType) {
        params.append("deliveryType", filters.deliveryType);
      }

      // Add the parameters to the URL
      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      axios
        .get(url, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then((response) => {
          if (response?.data?.data?.length === 0) {
            setLoading(false);
            if (
              (filters.isoStartDate || filters.isoEndDate) &&
              !filters.orderStatusType &&
              !filters.deliveryType
            ) {
              showToast({ toastText: "No orders within the dates selected", isSuccess: false });
            } else if (
              (!filters.isoStartDate || !filters.isoEndDate) &&
              filters.orderStatusType &&
              !filters.deliveryType
            ) {
              showToast({ toastText: "No orders with this status ", isSuccess: false });
            } else if (
              (!filters.isoStartDate || !filters.isoEndDate) &&
              !filters.orderStatusType &&
              filters.deliveryType
            ) {
              showToast({ toastText: "No orders with this delivery type", isSuccess: false });
            } else showToast({ toastText: "No orders match", isSuccess: false });
          } else {
            setOrderDisplayDetails(response.data.data);
            if (setPagination) {
              setPagination({
                currentPage: 1,
                itemsPerPage: 20,
                totalPages: 0,
                totalOrders: 0,
              });
            }
            setTimeout(() => {
              setLoading(false);
            }, 1000);
          }
        })
        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };
  const filterOrdersByDate = (
    isoEndDate,
    isoStartDate,
    setLoading,
    setOrderDisplayDetails,
    setVisualOrderStatus,
    showToast,
    setPagination = null
  ) => {
    const token = localStorageGetItem("userToken");
    setLoading(true);

    createAxios().then((axios) => {
      axios
        .get(`/admin/order/all?startDate=${isoStartDate}&endDate=${isoEndDate}`, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then((response) => {
          setLoading(false);
          if (response.data.data.length === 0) {
            showToast({
              toastText: "No orders within the dates selected",
              isSuccess: false,
            });
          } else {
            setOrderDisplayDetails(response.data.data);
            setVisualOrderStatus("");
            if (setPagination) {
              setPagination({
                currentPage: 1,
                itemsPerPage: 20,
                totalPages: 0,
                totalOrders: 0,
              });
            }
          }
        })
        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };

  const filterOrdersByStatus = (
    statusToFilter,
    setLoading,
    setOrderDisplayDetails,
    showToast,
    setPagination = null
  ) => {
    const token = localStorageGetItem("userToken");
    setLoading(true);

    createAxios().then((axios) => {
      axios
        .get(`/admin/order/all?orderStatus=${statusToFilter}`, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then((response) => {
          setLoading(false);
          setOrderDisplayDetails(response.data.data);
          if (setPagination) {
            setPagination({
              currentPage: 1,
              itemsPerPage: 20,
              totalPages: 0,
              totalOrders: 0,
            });
          } // Adjust based on your response structure
        })
        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };

  const createOrder = (body, setLoading, showToast) => {
    setLoading(true);
    const token = localStorageGetItem("userToken");

    createAxios().then((axios) => {
      axios
        .post("/admin/order", body, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then(async (response) => {
          setLoading(false);

          showToast({
            toastText: "Order created succesfully",
            isSuccess: true,
          });
          navigate("/admin/orders");
        })

        .catch((e) => {
          setLoading(false);
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  const editOrder = (body, orderId, setLoading, showToast) => {
    setLoading(true);
    const token = localStorageGetItem("userToken");

    createAxios().then((axios) => {
      axios
        .put(`/order/${orderId}`, body, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then(async (response) => {
          setLoading(false);

          showToast({
            toastText: "Order edited succesfully",
            isSuccess: true,
          });
          navigate("/admin/orders");
        })

        .catch((e) => {
          setLoading(false);

          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  const bulkStatusUpdate = (body, setLoading, showToast, setSelectedOrdersId = []) => {
    setLoading(true);
    const token = localStorageGetItem("userToken");

    createAxios().then((axios) => {
      axios
        .patch("/admin/order/bulk-update-status", body, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then(async (response) => {
          setLoading(false);

          showToast({
            toastText: "Order updated succesfully",
            isSuccess: true,
          });

          if (setSelectedOrdersId) {
            window.location.reload();
          } else {
            navigate("/admin/orders");
          }
        })

        .catch((e) => {
          // setLoading(false);

          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };
  const getDeliveryStates = (showToast, setDeliveryStates, setLoading) => {
    if (setLoading) setLoading(true);

    createAxios().then((axios) => {
      axios
        .get("/location/state")
        .then(async (response) => {
          setDeliveryStates(response?.data);
          if (setLoading) setLoading(false);
        })

        .catch((e) => {
          if (setLoading) setLoading(false);

          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };
  const getDeliveryLGAs = (stateId, showToast, setLgaOptions, setOriginalLgaOptions) => {
    createAxios().then((axios) => {
      axios
        .get(`/location/state/${stateId}/lga`)
        .then(async (response) => {
          const lgas = response?.data.map((lga) => ({
            value: lga.name,
            label: lga.name,
            id: lga.id,
            deliveryFee: lga.deliveryFee,
          }));

          setLgaOptions(lgas);
          setOriginalLgaOptions(lgas);
        })
        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };

  const getOrderDeliveryLGAs = (
    stateId,
    showToast,
    orderDetails,
    setOrderDetails,
    index,
    setLoading
  ) => {
    if (setLoading) setLoading(true);
    createAxios().then((axios) => {
      axios
        .get(`/location/state/${stateId}/lga`)
        .then(async (response) => {
          const lgas = response?.data.map((lga) => ({
            value: lga.name,
            label: lga.name,
            id: lga.id,
            deliveryFee: lga.deliveryFee,
          }));

          setOrderDetails((prev) =>
            prev.map((item, idx) =>
              idx === index ? { ...item, lgaOptions: lgas, originalLgaOptions: lgas } : item
            )
          );
          if (setLoading) setLoading(false);
        })
        .catch((e) => {
          if (setLoading) setLoading(false);
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };
  const getDeliveryLocations = (
    body,
    setLoading,
    showToast,
    setLocations,
    setDisplayLocations,
    setPagination
  ) => {
    const token = localStorageGetItem("userToken");
    setLoading(true);

    createAxios().then((axios) => {
      axios
        .post("/location/get-lgas", body, {
          headers: { "X-Auth-Token": token },
        })
        .then((response) => {
          const data = response?.data;
          setLocations(data?.data);
          setDisplayLocations(data?.data);
          setPagination({
            currentPage: data?.pagination.currentPage,
            totalPages: data?.pagination?.totalPages,
            totalLocations: data?.pagination?.total,
          });
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };

  const getGlobalDeliveryLocations = (showToast, onSuccess) => {
    const token = localStorageGetItem("userToken");

    createAxios().then((axios) => {
      axios
        .post(
          "/location/get-lgas",
          {},
          {
            headers: { "X-Auth-Token": token },
          }
        )
        .then((response) => {
          const data = response?.data;
          if (onSuccess) onSuccess(Array.isArray(data) ? data : data?.data);
        })
        .catch((e) => {
          const retriesDone = e.config?.["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };

  const addLocation = (body, setLoading, showToast) => {
    const token = localStorageGetItem("userToken");
    setLoading(true);

    createAxios().then((axios) => {
      axios
        .post("/location/lga", body, {
          headers: { "X-Auth-Token": token },
        })
        .then((response) => {
          setLoading(false);
          showToast({ toastText: "Location added successfully", isSuccess: true });
          navigate("/delivery-locations");
        })
        .catch((e) => {
          setLoading(false);
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };
  const editLocation = (lgaId, body, setLoading, showToast, onSuccess) => {
    const token = localStorageGetItem("userToken");
    setLoading(true);

    createAxios().then((axios) => {
      axios
        .put(`/location/lga/${lgaId}`, body, {
          headers: { "X-Auth-Token": token },
        })
        .then(async (response) => {
          setLoading(false);
          showToast({ toastText: "Location updated successfully", isSuccess: true });
          if (onSuccess) {
            onSuccess();
          } else {
            navigate("/delivery-locations");
          }
        })
        .catch((e) => {
          setLoading(false);
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };
  const deactivateLocation = (locationId, body, setShowDeleteModal, setLoading, showToast) => {
    setLoading(true);

    const token = localStorageGetItem("userToken");
    const userData = getParsedLocalStorageItem("userData");
    createAxios().then((axios) => {
      axios
        .put(`/location/lga/${locationId}`, body, {
          headers: { "X-Auth-Token": token },
        })
        .then(async (response) => {
          setLoading(false);
          setShowDeleteModal(false);
          showToast({
            toastText: "Location deactivated succesfully",
            isSuccess: true,
          });
          setTimeout(() => {
            if (window.location.pathname.replace(/\/$/, "") === "/delivery-locations") {
              window.location.reload();
            } else {
              navigate("/delivery-locations");
            }
          }, 1000);
        })

        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };
  const getLocation = (lgaId, setLoading, showToast, setFormData) => {
    const token = localStorage.getItem("userToken");
    setLoading(true);

    createAxios().then((axios) => {
      axios
        .get(`/location/lga/${lgaId}`, {
          headers: { "X-Auth-Token": token },
        })
        .then((response) => {
          const data = response?.data;
          setFormData({
            name: data?.name || "",
            stateId: data?.state?.id || "",
            deliveryFee: data?.deliveryFee || "",
            deliveryDays: data?.deliveryDays || [],
            trails: data?.trails || [],
          });

          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };

  const getTransactionsByDate = (
    isoEndDate,
    isoStartDate,
    setLoading,
    setTransactionOverviewData,
    showToast
  ) => {
    const token = localStorageGetItem("userToken");
    setLoading(true);

    createAxios().then((axios) => {
      axios
        .get(
          `/admin/reports/transactions-overview?from_date=${isoStartDate}&to_date=${isoEndDate}`,
          {
            headers: {
              "X-Auth-Token": token,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          if (response.data.length === 0) {
            showToast({
              toastText: "No transactions within the dates selected",
              isSuccess: false,
            });
          } else {
            setTransactionOverviewData(response.data);
          }
        })
        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };
  const getOrderOverviewData = (setLoading, setOrderOverviewDetails, showToast) => {
    const token = localStorageGetItem("userToken");
    setLoading(true);

    createAxios().then((axios) => {
      axios
        .get("/admin/reports/overview", {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then((response) => {
          setLoading(false);
          if (response.data.length === 0) {
            showToast({
              toastText: "No orders within the dates selected",
              isSuccess: false,
            });
          } else {
            setOrderOverviewDetails(response.data);
          }
        })
        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };

  const getOrderOverviewByDate = (
    isoEndDate,
    isoStartDate,
    setLoading,
    setOrderOverviewData,
    showToast
  ) => {
    const token = localStorageGetItem("userToken");
    setLoading(true);

    createAxios().then((axios) => {
      axios
        .get(`/admin/reports/orders-overview?from_date=${isoStartDate}&to_date=${isoEndDate}`, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then((response) => {
          setLoading(false);
          if (response.data.length === 0) {
            showToast({
              toastText: "No orders within the dates selected",
              isSuccess: false,
            });
          } else {
            setOrderOverviewData(response.data);
          }
        })
        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };
  const getAppTractionByDate = (
    isoStartDate,
    isoEndDate,
    selectedPeriod,
    setLoading,
    setTractionData,
    showToast
  ) => {
    const token = localStorageGetItem("userToken");
    setLoading(true);

    // Build query string based on input
    let query = "";

    if (isoStartDate && isoEndDate && isoStartDate !== "" && isoEndDate !== "") {
      query = `period=${selectedPeriod}&from_date=${isoStartDate}&to_date=${isoEndDate}`;
    } else {
      query = `period=${selectedPeriod}`;
    }

    createAxios().then((axios) => {
      axios
        .get(`/admin/reports/traction-overtime?${query}`, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then((response) => {
          setLoading(false);
          if (!response.data || response.data.length === 0) {
            showToast({
              toastText: "No data within the selected range.",
              isSuccess: false,
            });
          } else {
            setTractionData(response.data);
          }
        })
        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };

  const revertScheduledUpdate = (body, setLoading, showToast, onSuccess) => {
    setLoading(true);
    const token = localStorageGetItem("userToken");

    createAxios().then((axios) => {
      axios
        .post("/delivery-days/lga/override/revert", body, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then((response) => {
          setLoading(false);
          showToast({
            toastText: "Scheduled update cancelled successfully",
            isSuccess: true,
          });
          if (onSuccess) onSuccess();
        })
        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  const bulkUpdateDeliveryDays = (body, setLoading, showToast, onSuccess) => {
    setLoading(true);
    const token = localStorageGetItem("userToken");

    createAxios().then((axios) => {
      axios
        .post("/delivery-days/lga/bulk", body, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then((response) => {
          setLoading(false);
          showToast({
            toastText: `Bulk update successful`,
            isSuccess: true,
          });
          if (onSuccess) onSuccess();
        })
        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  const getCutOffTimes = (setLoading, showToast, setCutOffTimes) => {
    const token = localStorageGetItem("userToken");
    if (setLoading) setLoading(true);

    createAxios().then((axios) => {
      axios
        .get("/delivery-days/cut-off-time", {
          headers: { "X-Auth-Token": token },
        })
        .then((response) => {
          const data = response?.data?.data || response?.data;
          if (Array.isArray(data)) setCutOffTimes(data);
          if (setLoading) setLoading(false);
        })
        .catch((e) => {
          if (setLoading) setLoading(false);
          const retriesDone = e.config?.["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };

  const updateCutOffTimes = (body, setLoading, showToast, onSuccess) => {
    setLoading(true);
    const token = localStorageGetItem("userToken");

    createAxios().then((axios) => {
      axios
        .post("/delivery-days/cut-off-time/bulk", body, {
          headers: { "X-Auth-Token": token },
        })
        .then(() => {
          setLoading(false);
          showToast({ toastText: "Cut-off times updated successfully", isSuccess: true });
          if (onSuccess) onSuccess();
        })
        .catch((e) => {
          const retriesDone = e.config?.["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  const exportOrders = (deliveryDate = "", setLoading, showToast) => {
    const token = localStorageGetItem("userToken");
    setLoading(true);
    createAxios().then((axios) => {
      let url = "/admin/export/customers-orders";
      if (deliveryDate) {
        url += `?deliveryDate=${deliveryDate}`;
      }
      axios
        .get(url, {
          headers: {
            "X-Auth-Token": token,
          },
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          const formattedDate = deliveryDate ? deliveryDate.split("T")[0] : "";
          link.setAttribute(
            "download",
            `orders_export${formattedDate ? "_" + formattedDate : "_all"}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          setLoading(false);
          showToast({ toastText: "Export successful", isSuccess: true });
        })
        .catch(async (e) => {
          setLoading(false);
          if (e.response?.data instanceof Blob) {
            try {
              const text = await e.response.data.text();
              const parsed = JSON.parse(text);
              e.response.data = parsed;
            } catch (parseErr) {
              // leave e.response.data as-is if parsing fails
            }
          }
          const retriesDone = e.config?.["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  return {
    createOrder,
    getAdminSingleOrder,
    getAdminOrders,
    filterOrdersByStatus,
    bulkStatusUpdate,
    filterOrdersByDate,
    getDeliveryLGAs,
    getDeliveryStates,
    getOrderDeliveryLGAs,
    orderModify,
    filterOrders,
    editOrder,
    deleteOrder,
    getLatestOrders,
    getTransactionsByDate,
    getOrderOverviewByDate,
    getOrderOverviewData,
    getAppTractionByDate,
    getDeliveryLocations,
    getLocation,
    addLocation,
    editLocation,
    deactivateLocation,
    bulkUpdateDeliveryDays,
    revertScheduledUpdate,
    getGlobalDeliveryLocations,
    exportOrders,
    getCutOffTimes,
    updateCutOffTimes,
  };
};
